<template>
    <div>
        <div id="firebaseui-auth-container"></div>
    </div>
</template>
<script>
var firebase = require("firebase");
var firebaseui = require("firebaseui-ja");
require("firebaseui-ja/dist/firebaseui.css");
export default {
    mounted() {
        const title = "ログイン｜エモーションダイアリー"
        const description = "エモーションダイアリーのログイン画面です。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
        let uiConfig = {
            callbacks: {
                signInSuccess: function(user) {
                    if(user.emailVerified){
                        firebase.auth().currentUser.sendEmailVerification()
                    }
                    firebase.firestore().collection('user').doc(user.uid).set({
                        uid: user.uid,
                        name: user.displayName  
                    },{ merge: true }).then(()=>{
                        window.location.href = '/home';
                    });
                },
            },
            signInOptions: [
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ],
        }
        var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
        ui.start("#firebaseui-auth-container", uiConfig)
    }

}
</script>